import React from 'react';
import Card from 'react-bootstrap/Card'
import {ListGroup, ListGroupItem, Image} from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import cupSvg from '../assets/cup.svg'
import {Container, Button} from 'react-bootstrap'
import { FaEye } from 'react-icons/fa';

const CuppingCard = ({cupping, cuppingNum, tableId, isOwner }) => {
    const colorIfEven = () => {
      if (cuppingNum % 2 === 0) {
        return "coral"
      } else {
        return "#483730"
      }
    }
      return (
          <Container>
            <Card bg="white" text="black" className="card tableCuppingCard">
              <Card.Header style={{background: colorIfEven(), color: "white" }}>
                  
                  {!!isOwner ? <NavLink style={{textDecoration: "none"}} className="btn btn-primary updateScores btn-sm" to={`/score_cupping/${cupping.id}`}>{cupping.final_score && cupping.overall ? <FaEye/> : "Score"}</NavLink> : null}

                  <Image src={cupSvg} alt="coffe_bean" className="cardSvg cupSvg"/>&nbsp; 
                  <b><span id={cuppingNum}>{cuppingNum ? `#${cuppingNum} ` : null}</span>
                  {cupping.final_score && cupping.overall ? "Scored" : "In Progress"}</b>
                  {cuppingNum > 3 ? <Button variant="warning" className="w3-center floatRightBtn" size="sm" href="" onClick={() => window.scrollTo(0, 0)}>↑</Button> : null}     
              </Card.Header>        
              <Card.Body>
              <Card.Title>Final Score: <b style={{color: "rgb(251, 77, 61)"}}>{cupping.final_score ? cupping.final_score : "TBD"}</b></Card.Title>
                <ListGroup className="list-group-flush">
                    <ListGroupItem></ListGroupItem>
                    <ListGroupItem> Origin: <b>{cupping.origin ? `${cupping.origin}` : "TBD" } </b></ListGroupItem>
                    <ListGroupItem>Flavor: <b>{cupping.flavor ? cupping.flavor : "TBD"}</b></ListGroupItem>
                    <ListGroupItem>Acidity: <b>{cupping.acidity ? cupping.acidity : "TBD"}</b></ListGroupItem>
                    <ListGroupItem>Body: <b>{cupping.body ? cupping.body : "TBD"}</b></ListGroupItem>
                    <ListGroupItem>Aroma/Qualities: {!cupping.aroma_qualities ? "TBD" : null}
                      {cupping.aroma_qualities && cupping.aroma_qualities.length > 70 ? `${cupping.aroma_qualities.substring(0,70)}...(...)` : cupping.aroma_qualities}</ListGroupItem>
                    <ListGroupItem>Balance: <b>{cupping.balance ? cupping.balance : "TBD"} </b></ListGroupItem>
                </ListGroup>
            </Card.Body>
          </Card>&nbsp;
      </Container>
    )
}

export default CuppingCard